<template>
  <div>

    <multiselect v-model="value" :options="selectOptions" class="order-select mt-2" placeholder="Valor escolhido" :searchable="false" :allow-empty="false"></multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: { Multiselect },
    props: {
        options: {
            required: true,
            type: Object
        }
    },
    data () {
      return {
        value: null,
        selectOptions: Object.values(this.options)
      }

    },
    created(){
      this.value = Object.values(this.options)[0]
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

</style>
